import angular from 'angular';

import chatCtrl from './chat.controller';
import HeaderChatButton from './header-button/header-button.controller';
import WebsocketService from '../../services/websocket.service';
import onVisible from './chat-on-visible.directive';
import chatService from './chat.service';
import messageView from '~/components/chat/message-view/message-view.component';
import devTool from '~/components/chat/devtool/devtool.component';
import headerComponent from './header-button/header-button.component';

import './chat.scss';

export default angular
	.module('app.chat', [])
	.controller('HeaderChatButtonController', HeaderChatButton)
	.controller('ChatController', chatCtrl)

	.directive('onVisible', onVisible)

	.service('WebsocketService', WebsocketService)
	.service('chatService', chatService)

	.component('chatMessageView', messageView)
	.component('chatDevtool', devTool)
	.component('headerChat', headerComponent)
	.name;
